import styled from 'styled-components'
import { rem } from 'polished'
import Modal from 'LuxKit/Modal/Modal'
import { StyledModalBody } from 'LuxKit/Modal/ModalBody'
import { mediaQueryUp } from 'components/utils/breakpoint'

interface HeaderLayoutProps {
  $testId: string
}

/**
 * Shared modal shell for Maldives charter calendars. Keep search and offer pages on the
 * same modal/body layout so scroll, clipping, and header action behaviour stay identical.
 */
export const MaldivesCharterCalendarModalDesktop = styled(Modal)<HeaderLayoutProps>`
  ${mediaQueryUp.tablet} {
    &&& {
      max-width: min(var(--safe-size), ${rem(1550)});
    }
  }

  ${mediaQueryUp.desktop} {
    [data-testid="${props => props.$testId}-header"][data-testid] {
      grid-template-columns: min-content auto 1fr min-content;
      grid-template-areas:
        "prepended-action title header-actions appended-action"
        ". subtitle subtitle .";

      > .extension-area {
        grid-area: header-actions;
        margin-top: 0;
        justify-self: end;
        align-self: center;
      }

      @media (max-width: ${rem(1175)}) {
        grid-template-columns: min-content 1fr min-content;
        grid-template-areas:
          "prepended-action title appended-action"
          "header-actions header-actions header-actions"
          ". subtitle .";

        > .extension-area {
          justify-self: start;
          margin-top: ${rem(8)};
        }
      }
    }
  }
`

export const MaldivesCharterCalendarModalMobile = styled(Modal)`
  ${StyledModalBody} {
    overflow-x: hidden;
    touch-action: pan-y;
  }
`

export const MaldivesCharterCalendarModalBody = styled(StyledModalBody)`
  overflow-x: hidden;
  touch-action: pan-y;
`
